<template>
<div class="">
    <PageBreadcrumb />
    <!-- Single Detail -->
    <section class="singlesec py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <div class="single-news">
                        <div class="singleimage shrink-effect gradient-full">
                            <img src="../assets/images/news1.jpg" alt="" class="img-fluid w-100" />
                        </div>
                        <div class="single-title text-center my-4">
                            <h4>Apostles Update Week 27</h4>
                            <div class="author text-dark font-weight-bold">
                                <span><i class="fa fa-user-o"></i> admin on</span>
                                <span><i class="fa fa-calendar"></i> July 12, 2020</span>
                                <span><i class="fa fa-clock-o"></i> 16:48 </span>
                            </div>
                        </div>
                        <div id="vue-frame">
                            <iframe id="JotFormIFrame-91957283203864" title="FIFMI Giving Form" onload="window.parent.scrollTo(0,0)" allowtransparency="true" allowfullscreen="true" allow="geolocation; microphone; camera" src="https://form.jotform.co/91957283203864" frameborder="0" style=" min-width: 100%; height:539px; border:none;" scrolling="no" > </iframe>                        </div>
                        <hr>
                        <FormContacts />

                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <hr>
                    <!-- Start Latest News Sidebar -->
                    <LatestNews />
                    <!-- End Latest News Sidebar -->
                </div>
            </div>
        </div>
    </section>
    <!-- End Single Detail -->
</div>
</template>

<script>
import PageBreadcrumb from '@/components/PageBreadcrumb';
import LatestNews from "../components/LatestNews";
import VueFrame from 'vue-frame';
import FormContacts from "../components/FormContacts/FormContacts";
import SideBarExtras from "../components/SideBarExtras";

export default {
    name: 'OnlineGiving',
    components:{
        // eslint-disable-next-line vue/no-unused-components
        PageBreadcrumb, VueFrame, LatestNews, FormContacts, SideBarExtras
    },
    data() {
        return {
            formURL: "https://form.jotformeu.com/82563804184359"
        };
    },
    methods: {
        resizeIframe() {
            return ''
        }
    }
}

</script> 
